module.exports = __webpack_public_path__ + "d94e20c1/img/sliders-icon.a73c0453.svg";